<template>
  <div>
    <div class="head">
      <div class="left"></div>
      <div class="title">
        <div class="txt">实时监控</div>
        <the-now-time class="time"></the-now-time>
      </div>
      <div class="right"></div>
    </div>
    <div class="video-info">
      <!-- 轮播 -->
      <div class="video-list momitor-video-list">
        <div class="block" v-if="newArray.length > 0">
          <el-carousel
            trigger="click"
            height="146px"
            :autoplay="isAutoplay"
            indicator-position="none"
            arrow="always"
          >
            <el-carousel-item
              class="carousel-item clearfix"
              v-for="(item, index) in newArray"
              :key="index"
            >
              <template v-for="(inner, index) in item">
                <div class="video" :key="index" @click="select(inner)">
                  <span class="video-address">{{ inner.monitorName }}</span>
                  <!-- <span class="video-school">{{ schoolInfo.schoolName }}</span> -->
                </div>
              </template>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="list-none" v-else>暂无接入信息</div>
      </div>
    </div>
    <div class="play">
      <div class="video-play">
        <!-- <div class="play-title">
          <div class="title-list">
            <span class="list-li">监控一</span>
          </div>
          <div class="title-list">
            <span class="list-li">监控二</span>
          </div>
          <div class="title-list">
            <span class="list-li">监控三</span>
          </div>
          <div class="title-list">
            <span class="list-li">监控四</span>
          </div>
        </div> -->
        <div class="play-list">
          <template v-if="playVideoList.length > 0">
            <div
              class="video-box"
              v-for="(value, index) in playVideoList"
              :key="value.id"
              ref="video_box"
            >
              <tc-player-unit
                v-if="value.playStatus == true"
                :ref="'tcplayer' + index"
                :index="index"
                :playVideo="value"
                :widthHeigt="[441, 246]"
              ></tc-player-unit>
              <div class="no-play" v-if="value.playStatus == false">
                <img
                  src="@/assets/img/schoolMonitorCenter/paperbroke.png"
                  alt=""
                />
                <div class="tip">暂无接入信息</div>
              </div>
            </div>
          </template>
          <!-- 视频不够 4 个时显示 -->
          <template v-if="noPlayVideoList.length > 0">
            <div
              class="video-box no-play"
              v-for="(value, index) in noPlayVideoList"
              :key="index"
            >
              <img
                src="@/assets/img/schoolMonitorCenter/paperbroke.png"
                alt=""
              />
              <div class="tip">暂无接入信息</div>
            </div>
          </template>
          <monitor-capture
            :playVideoList="playVideoList"
            :noPlayVideoList="noPlayVideoList"
          ></monitor-capture>
        </div>
      </div>
    </div>
    <div class="info">
      <momitor-alert></momitor-alert>
    </div>
    <!-- 选择窗口播放弹窗 -->
    <el-dialog
      class="select-dailog"
      :visible.sync="dialogVisible"
      :modal-append-to-body="false"
      :append-to-body="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      style="padding: 0"
    >
      <div class="content">
        <div class="select-close" @click="dialogVisible = false">关闭</div>
        <div class="content-title">
          <img
            src="@/assets/img/schoolMonitorCenter/select-video-seat-icon.png"
            alt=""
          />
          <span>选择视频播放窗口</span>
        </div>
        <div class="content-select">
          <div class="select-list">
            <div class="select-li" @click="selectVideoSeat(0)">窗口一</div>
            <div class="select-li" @click="selectVideoSeat(1)">窗口二</div>
          </div>
          <div class="select-list">
            <div class="select-li" @click="selectVideoSeat(2)">窗口三</div>
            <div class="select-li" @click="selectVideoSeat(3)">窗口四</div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import TcPlayerUnit from "./components/TcPlayerUnit";
import monitorCapture from "./components/monitorCapture";
import theNowTime from "./components/theNowTime";
import momitorAlert from "./components/momitorAlert";
export default {
  name: "monitoringCenter",
  components: {
    TcPlayerUnit,
    monitorCapture,
    theNowTime,
    momitorAlert
  },
  data() {
    return {
      schoolInfo: this.$store.state.schoolInfo,
      userInfo: JSON.parse(sessionStorage.getItem("userInfo")),
      videoList: [],
      playVideoList: [],
      noPlayVideoList: [],
      isAutoplay: false,
      newArray: [],
      selectVideo: {},
      dialogVisible: false
    };
  },
  created() {
    this.getRegionMonitorList();
  },
  mounted() {},
  computed: {},
  watch: {},
  methods: {
    // 校园监控中心-获取监控区域 and 区域摄像头
    async getRegionMonitorList() {
      var newParamData = {
        schoolId: this.$store.state.schoolId
      };
      // var newParamData = this.$store.state.schoolId
      let res = await this.$Http.getRegionMonitorList(newParamData);
      if (res.code == 200) {
        this.videoList = res.data;
        this.modify();
        let videoList = this.videoList;
        // let videoList = [];
        // console.log(videoList);
        let newI = videoList.length <= 4 ? videoList.length : 4;
        // console.log(newI + '----newI');
        let playVideoList = [];
        for (var i = 0; i < newI; i++) {
          playVideoList.push({
            playStatus: true,
            id: "video-" + i,
            m3u8_sd: videoList[i].hls,
            m3u8_hd: videoList[i].hlsHd,
            flv_sd: videoList[i].flv,
            flv_hd: videoList[i].flvHd,
            videoAddress: videoList[i].monitorName
          });
        }
        if (playVideoList.length > 3) {
          this.playVideoList = playVideoList;
        } else if (playVideoList.length == 3) {
          let arrTemp = [
            {
              playStatus: false,
              id: "video-" + 3
            }
          ];
          playVideoList = playVideoList.concat([], arrTemp);
          this.playVideoList = playVideoList;
        } else if (playVideoList.length == 2) {
          let arrTemp = [
            {
              playStatus: false,
              id: "video-" + 2
            },
            {
              playStatus: false,
              id: "video-" + 3
            }
          ];
          playVideoList = playVideoList.concat([], arrTemp);
          // console.log(playVideoList);
          this.playVideoList = playVideoList;
        } else if (playVideoList.length == 1) {
          let arrTemp = [
            {
              playStatus: false,
              id: "video-" + 1
            },
            {
              playStatus: false,
              id: "video-" + 2
            },
            {
              playStatus: false,
              id: "video-" + 3
            }
          ];
          playVideoList = playVideoList.concat([], arrTemp);
          this.playVideoList = playVideoList;
        } else {
          this.showNoVideoList(0);
          this.playVideoList = playVideoList;
        }
      } else if (res.code == 101) {
        // this.videoList = [];
        this.playVideoList = [];
        this.showNoVideoList(0);
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 显示没有视频时的信息
    showNoVideoList(newI) {
      let noPlayVideoList = [];
      if (newI < 4) {
        var imgNum = 4 - newI;
        for (var i = 0; i < imgNum; i++) {
          noPlayVideoList.push(imgNum);
        }
      }
      this.noPlayVideoList = noPlayVideoList;
      // console.log(this.noPlayVideoList);
    },
    // 选择在哪个窗口播放视频
    selectVideoSeat(seat) {
      this.dialogVisible = false;
      let selVideo = {
        playStatus: true,
        id: "video-" + seat,
        m3u8_sd: this.selectVideo.m3u8_sd,
        m3u8_hd: this.selectVideo.m3u8_hd,
        flv_sd: this.selectVideo.flv_sd,
        flv_hd: this.selectVideo.flv_hd,
        videoAddress: this.selectVideo.monitorName
      };
      this.playVideoList[seat] = selVideo;
      // console.log(this.playVideoList)
    },
    // 修改返回视频数组结构
    modify() {
      let newArray = [];
      if (this.videoList.length > 0) {
        let videoList = this.videoList;
        // this.schoolName = this.eduSchoolInfo.list[0].schoolName;
        let start = 0;
        let end = 5;
        let length = videoList.length;
        let times = parseInt(length / 5);
        if (times * 5 <= length) {
          times++;
        }
        for (var i = 0; i < times; i++) {
          let sliceArray = videoList.slice(start, end);
          start = end;
          end = end + 5;
          if (sliceArray.length > 0) {
            newArray.push(sliceArray);
          }
        }
      }
      this.newArray = newArray;

      // console.log(newArray);
    },
    // 选择视频
    select(item) {
      // console.log(item);
      this.selectVideo = {
        playStatus: true,
        id: "",
        m3u8_sd: item.hls,
        m3u8_hd: item.hlsHd,
        flv_sd: item.flv,
        flv_hd: item.flvHd,
        videoAddress: item.monitorName
      };
      this.dialogVisible = true;
    }
  },
  destroyed() {}
};
</script>
<style lang="scss" scoped>
.head {
  margin: 0 auto;
  width: calc(100% - 80px);
  display: flex;
  justify-content: space-between;
  align-items: center;
  .left {
    width: 252px;
    height: 20px;
    background: url("~@/assets/img/schoolMonitorCenter2/title-left.png") center
      center no-repeat;
    background-size: 100% 100%;
  }
  .title {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .txt {
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #67e2e9;
    }
  }
  .right {
    width: 252px;
    height: 20px;
    background: url("~@/assets/img/schoolMonitorCenter2/title-right.png") center
      center no-repeat;
    background-size: 100% 100%;
  }
}
.video-info {
  width: calc(100% - 80px);
  margin: 10px auto 0 auto;
  .video-list {
    height: 146px;
    /deep/ .el-carousel__arrow {
      width: 210px;
      height: 146px;
      color: #a8c5f9;
      border-radius: 0;
      background: url("~@/assets/img/schoolMonitorCenter2/arrow-bg.png") center
        center no-repeat;
      background-size: 100% 100%;
      &.el-carousel__arrow--left {
        left: 0;
      }
      &.el-carousel__arrow--right {
        right: 0;
      }
      .el-icon-arrow-left {
        width: 63px;
        height: 35px;
        background: url("~@/assets/img/schoolMonitorCenter2/arrow-left.png")
          center center no-repeat;
        background-size: 100% 100%;
        &:before {
          display: none;
        }
      }
      .el-icon-arrow-right {
        width: 63px;
        height: 35px;
        background: url("~@/assets/img/schoolMonitorCenter2/arrow-right.png")
          center center no-repeat;
        background-size: 100% 100%;
        &:before {
          display: none;
        }
      }
    }
    .carousel-item {
      display: flex;
      justify-content: center;
      align-items: center;
      .video {
        width: 260px;
        height: 146px;
        float: left;
        margin-right: 18px;
        cursor: pointer;
        background: url("~@/assets/img/schoolMonitorCenter/video-list-bg.png")
          center center no-repeat;
        background-size: 100% 100%;
        text-align: center;
        position: relative;
        &:last-child {
          margin-right: 0;
        }
        &.active {
          box-shadow: 0px 4px 20px 0px #98d3ff;
        }
      }
      .video-address {
        display: inline-block;
        width: 260px;
        height: 26px;
        background: rgba(15, 26, 77, 0.7);
        font-size: 12px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #dbe1ff;
        line-height: 26px;
        text-align: center;
        overflow: hidden;
        word-break: break-all;
        text-overflow: ellipsis;
        white-space: nowrap;
        position: absolute;
        left: 0;
        bottom: 0;
      }
      .video-school {
        display: inline-block;
        width: 121px;
        height: 26px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 26px;
        overflow: hidden;
        word-break: break-all;
        text-overflow: ellipsis;
        white-space: nowrap;
        background: rgba(0, 0, 0, 0.2);
        position: absolute;
        left: 0;
        bottom: 0;
      }
    }
    .list-none {
      height: 128px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #ffffff;
      font-size: 14px;
    }
  }
}
.play {
  padding-top: 10px;
  .video-play {
    margin: 0 auto;
    width: calc(100% - 80px);
    // height: 284px;
    .play-title {
      margin: 20px 0 4px 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .title-list {
        width: 443px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .list-li {
        width: 69px;
        height: 24px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: url("~@/assets/img/schoolMonitorCenter/big-data-school-video-title-bg.png")
          center center no-repeat;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #c4cdff;
      }
    }
    .play-list {
      width: 100%;
      height: 250px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: relative;
      // perspective: 500;
      // -webkit-perspective: 500;
    }
    .video-box {
      width: 445px;
      height: 250px;
      padding: 2px;
      // padding: 16px;
      background: url("~@/assets/img/schoolMonitorCenter2/video-bg.png")
        center center no-repeat;
      background-size: 100% 100%;
      // transition: all 0.5s ease;
      // &:hover {
      //   transform: scale(1.1);
      // }
      /deep/ .video {
        width: 100%;
        height: 100%;
        video {
          width: 100%;
          height: 100%;
          object-fit: fill;
        }
      }
      &.no-play {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        .tip {
          margin-top: 10px;
          color: #ffffff;
          font-size: 14px;
        }
      }
      .no-play {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        .tip {
          margin-top: 10px;
          color: #ffffff;
          font-size: 14px;
        }
      }
    }
  }
}
.info {
  margin: 10px auto 0 auto;
  width: calc(100% - 80px);
}
.select-dailog {
  /deep/ .el-dialog__header {
    display: none;
  }
  /deep/ .el-dialog__body {
    padding: 0;
  }
  /deep/ .el-dialog {
    width: 450px;
    background: transparent;
  }
  /deep/ .el-dialog__body {
    width: 450px;
    background: transparent;
    padding: 0;
  }
  .content {
    padding-top: 12px;
    width: 450px;
    height: 320px;
    // 已修改
    background: url("~@/assets/img/hiddenDangerNow/hidden-detail-dialog-bg.png")
      center center no-repeat;
    background-size: 100% 100%;
    position: relative;
    .select-close {
      width: 56px;
      height: 24px;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #d7deff;
      text-align: center;
      line-height: 25px;
      letter-spacing: 1px;
      position: absolute;
      top: 10px;
      right: 10px;
      cursor: pointer;
    }
    .content-title {
      display: flex;
      justify-content: center;
      align-items: center;
      span {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 22px;
      }
    }
    .content-select {
      margin-top: 45px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
      .select-list {
        display: flex;
        justify-content: center;
        align-items: center;
        .select-li {
          margin-bottom: 24px;
          margin-right: 32px;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 146px;
          height: 52px;
          box-shadow: 8px -5px 18px 0px #526ecc inset;
          border-radius: 1px;
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #c4f0ff;
          line-height: 22px;
          cursor: pointer;
          &:last-child {
            margin-right: 0;
          }
        }
      }
    }
  }
}
</style>
